///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.common = abcsetup.rfq.common || {};
abcsetup.rfq.common.id = abcsetup.rfq.common.id || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.common = {
    init: function() {
        // Remove attached item button clicked
        $(document).on('click', '.btn.btn-attach', function() {
            abcsetup.alerts.prompt('Attach an Item', 'Please specify a the item description:', function (resp) {
                if (resp[0] == true) {
                    abcsetup.rfq.common.attachItem(resp[1]);
                }
            }, true);
            return false;
        });

        // Remove attached item button clicked
        $(document).on('click', '#item-accordion .remove', function() {
            var item = $(this);
            abcsetup.alerts.confirm('Remove Item', 'Are you sure you want to remove this item?', function (resp) {
                if (resp) {
                    item.closest('.card').fadeOut(function() {
                        $(this).remove();

                        if ($('#item-accordion .card:visible').length == 0) {
                            $('#attach_message').show();
                            $(".control-buttons").find("button").attr("disabled", true);
                        }
                    });
                }
            });

            return false;
        });

        // Save Item button clicked
        $(document).on('click', '.btn.save-item', function() {
            var itemPanel = $(this).closest('.card-body');

            var valid = abcsetup.rfq.common.validateItem(itemPanel);

            if (itemPanel.find(':input.bid').val() == '0' && valid) {
                abcsetup.rfq.common.ignoreItem(itemPanel);
            }

            return false;
        });

        // Accordion item clicked
        $('[data-toggle="collapse"]').off('click.accordion_item').on('click.accordion_item', function() {
            $('#item-accordion').data('item', $($(this).attr("href")).attr('id'));
        });

        // Accordion open/closed
        $(document).on('show.bs.collapse', '.collapse', function() {
            $('#item-accordion').data('showing', true).data('item', $(this).attr('id'));
            $(this).parent().find(".fa").toggleClass("down");

            if (!$(this).parent().find(".card-header").hasClass('list-group-item-success')) {
                $(this).parent().find(".card-header").addClass("list-group-item-primary");
            }

        }).on('hide.bs.collapse', '.collapse', function(event) {
            // Prevent other items from collapsing when opening a new one
            if ($('#item-accordion').data('showing') && $('#item-accordion').data('item') != $(this).attr('id')) {
                event.preventDefault();
                return;
            }

            $('#item-accordion').data('showing', false);
            $(this).parent().find(".fa").toggleClass("down");
            $(this).parent().find(".card-header").removeClass("list-group-item-primary");
        });

        // The bid dropdown has changed
        $(document).on('change', 'select.bid', function() {
            var itemPanel = $(this).closest('.card-body');

            // Change the card header class and icon based on value
            if ($(this).val() == 1) {
                itemPanel.closest('.card').find('.card-header').removeClass('ignored list-group-item-success');
                itemPanel.closest('.card').find('h5.title i.fa-eye-slash').replaceWith('<i class=""></i>');
            } else if ($(this).val() == '0') {
                itemPanel.find(':input.ndc').val('');
                itemPanel.closest('.card').find('.card-header').addClass('ignored').removeClass('list-group-item-success');
                itemPanel.closest('.card').find('h5.title i:first').replaceWith('<i class="fas fa-eye-slash"></i>');
            }

            // Find if the user is submitting any items
            var bidItems = $('select.bid').filter(function() { return $(this).val() == 1; });

            // The user isn't submitting any items - dont force the requirement of the offer letter
            if (bidItems.length === 0) {
                $('#rfq_bid_request_attachment, .uploader-container .errorMsg').hide();
                $('input.attachment_file[data-idx="rfq_bid_request_attachment"]').hide().attr('required', false);
            // If the user who initiated the bid request is NOT the grx_cm and the bid type is Additional Usage,
            // the offer letter is optional
            } else if (bidItems.length !== 0 && $('#bid_type').val() == 28 && $('#create_role_class').val() != 'grx_cm') {
                $('#rfq_bid_request_attachment, .uploader-container .errorMsg').show().removeClass('btn-danger');
                $('input.attachment_file[data-idx="rfq_bid_request_attachment"]').attr('required', false);
            } else if (bidItems.length !== 0 && $('#bid_type').val() == 28 && $('#create_role_class').val() == 'grx_cm') {
                $('#rfq_bid_request_attachment, .uploader-container .errorMsg').show().addClass('btn-danger');
                $('input.attachment_file[data-idx="rfq_bid_request_attachment"]').attr('required', true);
            } else {
                if ($('input[data-idx="rfq_bid_request_attachment"]').val() == '') {
                    $('#rfq_bid_request_attachment').show();
                    $('input.attachment_file[data-idx="rfq_bid_request_attachment"]').show().attr('required', true);
                }
            }
        });

        // Block the UI when a button is clicked
        $(document).on('click', '.control-buttons .btn', function() {
            abcsetup.blockUI(true);
        });
    },

    /**
     * Attach the validated item to the RFQ bid
     */
    attachItem: function(itemdesc) {
        var template = $('.item-template').clone();
        template.removeClass('item-template hide');

        var id = 'new_' + abcsetup.randomString();
        template.find('.card-header').attr('href', '#' + id);
        template.find('#card-body').attr('id', id);
        template.find('.title').html(itemdesc);

        var html = template[0].outerHTML;
        html = abcsetup.replaceAll(html, '_NEW_ITEM_', id);

        $('#attach_message').hide();
        $(".control-buttons").find("button").attr("disabled", false);
        $('#item-accordion').append(html);
        $('#item-accordion input[name="itemdescfull[' + id + ']"]').val(itemdesc);

        $('.collapse').collapse({toggle: false});

        // Accordion item clicked
        $('[data-toggle="collapse"]').off('click.accordion_item').on('click.accordion_item', function() {
            $('#item-accordion').data('item', $($(this).attr("href")).attr('id'));
        });
    },

    /**
     * Validate the item form
     *
     * @param {*} itemPanel
     */
    validateItem: function(itemPanel, init = false) {
        var valid = true;

        var fields = ':input:visible';

        if (init) {
            fields = ':input';
        }

        // We're not initing the panel, validate the fields
        itemPanel.find(fields).each(function() {
            if (!$(this)[0].checkValidity()) {
                valid = false;
            }
        });

        if (valid) {
            if (!init) {
                itemPanel.closest('.card').find('.card-header').trigger('click');

                // The item has passed validation, pop a message
                abcsetup.alerts.show('Item Validation', 'The item has passed validation');
            }

            itemPanel.closest('.card').find('.card-header').addClass('list-group-item-success').removeClass('ignored');
            itemPanel.closest('.card').find('h5.title i:first').replaceWith('<i class="fas fa-check"></i>');
        }

        // Clear any lingering invalid field items
        if (init) {
            itemPanel.find(':input.invalid').removeClass('invalid');
            itemPanel.find('.errorMsg').remove();
        }

        return valid;
    },

    /**
     * Validate the item form
     *
     * @param {*} itemPanel
     */
    ignoreItem: function(itemPanel, init = false) {
        if (!init) {
            itemPanel.closest('.card').find('.card-header').trigger('click');
        }

        itemPanel.closest('.card').find('.card-header').addClass('ignored list-group-item-success');
        itemPanel.closest('.card').find('h5.title i:first').replaceWith('<i class="fas fa-eye-slash"></i>');
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {
        var errorField = $('form.rfq-bid-form').find('.invalid').first();

        if (!errorField.is(":visible")) {
            var itemPanel = errorField.closest('.card-body');
            itemPanel.closest('.card').find('.card-header').trigger('click');
        }
    },

    /**
     * Yajra datatables have been init - this is the event
     */
    tableDrawCallback: function(table) {
        if (table == 'app_data_tables_r_f_q_bid_request_data_table' || table == 'app_data_tables_r_f_q_bid_request_data_table_new') {
            // Update events that are paused
            $('#' + table + ' tr').each(function () {
                if ($(this).find('td:eq(0)').find('.fa-exclamation-triangle').length) {
                    $(this).addClass('warning');
                }

                if ($(this).find('td:eq(0)').find('.fa-pen').length) {
                    $(this).addClass('pending');
                }

                if ($(this).find('td:eq(0)').find('.fa-pause').length) {
                    $(this).addClass('paused');
                }

                if ($(this).find('td:eq(0)').find('.fa-ban').length) {
                    $(this).addClass('deleted');
                }
            });
        }
    },
};